// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 24 24%27 stroke=%27%2364748b%27%3E%3Cpath stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M19 9l-7 7-7-7%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-ai-test {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.admin-ai-test h1 {
  color: #333;
  margin-bottom: 8px;
  font-size: 28px;
  font-weight: 600;
}

.admin-ai-test .subtitle {
  color: #666;
  margin-bottom: 32px;
  font-size: 16px;
}

.test-form-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
}

.test-form-section h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-row.single {
  grid-template-columns: 1fr;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group textarea,
.form-group select {
  padding: 12px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
  background: white;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
  font-family: inherit;
}

/* Upload Mode Toggle - Moved to folder management section */

/* Folder Upload Section */
.folder-upload-section {
  padding: 20px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  background: #f9f9f9;
  margin-bottom: 20px;
}

.folder-upload-section .form-group {
  margin-bottom: 15px;
}

.folder-upload-section input[type="file"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
}

.file-info {
  margin-top: 10px;
}

.selected-files {
  background: white;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.selected-files ul {
  margin: 10px 0 0 0;
  padding-left: 20px;
  max-height: 150px;
  overflow-y: auto;
}

.selected-files li {
  margin-bottom: 5px;
  font-size: 14px;
  color: #666;
}

.upload-actions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.upload-actions .btn {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 6px;
}

.s3-preview-section {
  margin-top: 20px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.s3-preview-section h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.s3-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.s3-image-item {
  background: white;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
  border: 1px solid #e2e8f0;
  transition: transform 0.2s;
}

.s3-image-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.s3-image-item img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 4px;
}

.s3-image-item .filename {
  font-size: 10px;
  color: #666;
  word-break: break-all;
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}

.btn-primary {
  background: #4f46e5;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #4338ca;
  transform: translateY(-1px);
}

.btn-secondary {
  background: #6b7280;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background: #555c68;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #059669;
}

.btn-outlined {
  background: transparent;
  color: #1976d2;
  border: 2px solid #1976d2;
  height: 40px;
  min-width: 100px;
  width: auto;
  padding: 8px 16px;
  font-weight: 600;
  text-transform: none;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.btn-outlined:hover:not(:disabled) {
  background: rgba(25, 118, 210, 0.04);
  border-width: 2px;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.results-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.results-header h2 {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.batch-status {
  background: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.status-item {
  text-align: center;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.status-number {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 4px;
}

.status-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-completed .status-number {
  color: #10b981;
}

.status-failed .status-number {
  color: #ef4444;
}

.status-processing .status-number {
  color: #f59e0b;
}

.status-pending .status-number {
  color: #6b7280;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 12px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4f46e5, #7c3aed);
  transition: width 0.3s ease;
}

.generation-results {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

/* New Generation Card Styles */
.generation-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.generation-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #4f46e5;
}

/* Card Header */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.status-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.completed {
  background: #dcfce7;
  color: #166534;
}

.status-badge.failed {
  background: #fef2f2;
  color: #991b1b;
}

.status-badge.processing {
  background: #fef3c7;
  color: #92400e;
}

.status-badge.pending {
  background: #f1f5f9;
  color: #475569;
}

.generation-id {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

/* Progress Circle */
.progress-circle-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-circle {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-ring {
  transform: rotate(-90deg);
  transition: all 0.3s ease;
}

.progress-ring-circle {
  transition: stroke-dashoffset 0.3s ease;
}

.progress-text {
  position: absolute;
  font-size: 10px;
  font-weight: 600;
  color: #374151;
}

/* Images Section */
.images-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 16px 20px;
}

.image-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.image-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.2s ease;
  background: #f8fafc;
}

.card-image:hover {
  transform: scale(1.02);
}

/* Specific styling for videos in cards */
.card-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f8fafc;
}

.card-image video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f8fafc;
}

.no-image-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: #6b7280;
  font-size: 12px;
  font-style: italic;
  border: 2px dashed #cbd5e1;
}

.processing-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #4f46e5;
}

.processing-indicator .spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #4f46e5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Card Footer */
.card-footer {
  padding: 12px 20px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 4px 0;
}

.detail-item.error {
  color: #dc2626;
  background: #fef2f2;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #fecaca;
}

.detail-label {
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 10px;
}

.detail-value {
  color: #6b7280;
  font-size: 11px;
  text-align: right;
  max-width: 60%;
  word-break: break-all;
}

.detail-value.filename {
  font-family: monospace;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
}

/* Legacy styles for backward compatibility */
.generation-item {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  transition: transform 0.2s;
}

.generation-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.generation-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 8px;
}

.generation-info {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.history-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.history-header h2 {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.history-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
}


.history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
}

.history-table th,
.history-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.history-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #374151;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.history-table tr:hover {
  background: #f8fafc;
}

/* Table Image Cells */
.image-cell {
  width: 120px;
  padding: 8px;
  text-align: center;
}

/* Column Widths */
.history-table th:nth-child(1),
/* ID */
.history-table td:nth-child(1) {
  width: 60px;
}

.history-table th:nth-child(2),
/* Status */
.history-table td:nth-child(2) {
  width: 100px;
}

.history-table th:nth-child(3),
/* Format */
.history-table td:nth-child(3) {
  width: 80px;
}

.history-table th:nth-child(4),
/* Input */
.history-table td:nth-child(4) {
  width: 140px;
}

.history-table th:nth-child(5),
/* Output */
.history-table td:nth-child(5) {
  width: 140px;
}

.history-table th:nth-child(6),
/* Created */
.history-table td:nth-child(6) {
  width: 140px;
}

.history-table th:nth-child(7),
/* Time */
.history-table td:nth-child(7) {
  width: 80px;
}

.history-table th:nth-child(8),
/* Actions */
.history-table td:nth-child(8) {
  width: 80px;
}

.table-image-container {
  width: 100px;
  height: 80px;
  margin: 0 auto;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-image-container:hover {
  border-color: #4f46e5;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.2);
}

.table-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #f8fafc;
}

.table-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #f8fafc;
}

.table-image-placeholder {
  width: 100px;
  height: 80px;
  margin: 0 auto;
  border-radius: 6px;
  border: 2px dashed #cbd5e1;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #6b7280;
  text-align: center;
  line-height: 1.2;
  padding: 4px;
}

.table-image-error {
  width: 100px;
  height: 80px;
  margin: 0 auto;
  border-radius: 6px;
  border: 2px solid #fecaca;
  background: #fef2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #dc2626;
  text-align: center;
  line-height: 1.2;
  padding: 4px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
}

.pagination button {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.pagination button:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination .active {
  background: #4f46e5;
  color: white;
  border-color: #4f46e5;
}

.error-message {
  background: #fef2f2;
  color: #991b1b;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #fecaca;
}

.success-message {
  background: #f0fdf4;
  color: #166534;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #bbf7d0;
}

.info-message {
  background: #eff6ff;
  color: #1e40af;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #bfdbfe;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #4f46e5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.tab-navigation {
  display: flex;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 32px;
  padding: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.tab-button {
  flex: 1 1;
  padding: 16px 24px;
  background: transparent;
  border: none;
  font-size: 15px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
}

.tab-button:hover:not(.active) {
  color: #374151;
  background: #f9fafb;
  transform: translateY(-1px);
}

.tab-button.active {
  color: #ffffff;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  transform: translateY(-2px);
}

.tab-button.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 8px;
  pointer-events: none;
}

.tab-icon {
  font-size: 18px;
  transition: transform 0.2s ease;
}

.tab-button:hover .tab-icon {
  transform: scale(1.1);
}

.tab-button.active .tab-icon {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

@media (max-width: 768px) {
  .admin-ai-test {
    padding: 16px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn {
    justify-content: center;
  }

  .s3-images-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }

  .generation-results {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .generation-card {
    margin-bottom: 16px;
  }

  .card-header {
    padding: 12px 16px;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .status-section {
    width: 100%;
    justify-content: space-between;
  }

  .progress-circle-container {
    align-self: flex-end;
  }

  .images-section {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }

  .image-wrapper {
    height: 200px;
  }

  .card-footer {
    padding: 12px 16px;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .detail-value {
    text-align: left;
    max-width: 100%;
  }

  .history-filters {
    grid-template-columns: 1fr;
  }

  .history-table {
    font-size: 12px;
  }

  .history-table th,
  .history-table td {
    padding: 8px 4px;
  }

  .image-cell {
    width: 80px;
    padding: 4px;
  }

  .table-image-container {
    width: 80px;
    height: 60px;
  }

  .table-image-placeholder,
  .table-image-error {
    width: 80px;
    height: 60px;
    font-size: 9px;
  }

  .status-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .tab-navigation {
    flex-wrap: wrap;
    padding: 4px;
    margin-bottom: 24px;
  }

  .tab-button {
    flex: 1 1;
    min-width: 120px;
    padding: 14px 20px;
    font-size: 14px;
    min-height: 44px;
  }

  .tab-icon {
    font-size: 16px;
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

/* Image modal should appear above details modal */
.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.image-modal {
  max-width: 800px;
}

/* Video styling in modals */
.image-modal video {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  background: #000;
  border-radius: 8px;
}

.details-modal {
  max-width: 1000px;
  width: 90vw;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #e2e8f0;
  color: #374151;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Details Content Styles */
.details-content {
  max-width: 100%;
}

.details-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  flex-wrap: wrap;
}

.format-info,
.time-info {
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
}

/* Details modal specific image section */
.details-content .images-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

/* For video generation with 4 steps, use 2x2 grid */
.details-content .images-section:has(.image-container:nth-child(4)) {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.details-content .image-container {
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.image-container h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.image-preview {
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  transition: border-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  max-height: 300px;
  height: 250px;
}

.image-preview:hover {
  border-color: #4f46e5;
}

.no-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
  color: #6b7280;
  font-style: italic;
  background: #f1f5f9;
  border-radius: 6px;
  border: 2px dashed #cbd5e1;
}

.details-section {
  background: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.details-section h4 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.details-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Details modal specific detail items */
.details-content .detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.details-content .detail-item strong {
  color: #374151;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.details-content .detail-item:not(.error) {
  color: #6b7280;
  font-size: 14px;
}

.details-content .detail-item.error {
  color: #dc2626;
  background: #fef2f2;
  border-color: #fecaca;
}

.details-content .detail-item.error strong {
  color: #991b1b;
}

/* API URL styling in details */
.api-url {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #475569;
  border: 1px solid #e2e8f0;
  word-break: break-all;
  display: inline-block;
  max-width: 100%;
  cursor: help;
}

/* Generation parameters section styling */
.details-list .detail-item:nth-child(n+7) {
  border-top: 1px solid #e2e8f0;
  padding-top: 12px;
  margin-top: 8px;
}

.details-list .detail-item:nth-child(7) {
  border-top: 2px solid #4f46e5;
  padding-top: 12px;
  margin-top: 12px;
}

.details-list .detail-item:nth-child(7) strong {
  color: #4f46e5;
  font-weight: 600;
}

/* Button Styles for Table */
.btn-small {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 6px;
}

/* Responsive Modal */
@media (max-width: 768px) {
  .modal-content {
    max-width: 95vw;
    max-height: 95vh;
  }

  .images-section {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .images-section:has(.image-container:nth-child(4)) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }

  .details-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    padding: 12px 20px;
  }
}

/* ===== NEW PROFESSIONAL UI STYLES ===== */

/* Generation Type Selection */
.generation-type-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
}

.generation-type-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 16px;
}

.type-option {
  position: relative;
}

.type-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.type-label {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.type-option input[type="radio"]:checked+.type-label {
  border-color: #4f46e5;
  background: #f8fafc;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.type-option:hover .type-label {
  border-color: #4f46e5;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.type-icon {
  font-size: 32px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border-radius: 8px;
}

.type-content {
  flex: 1 1;
}

.type-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.type-description {
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
}

/* API Configuration Section */
.api-configuration-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
}

/* API Cards */
.api-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.api-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.api-card-header {
  background: white;
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.api-card-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.step-indicator {
  background: #4f46e5;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  min-width: 60px;
  text-align: center;
}

.api-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-success {
  color: #059669;
  font-size: 14px;
  font-weight: 500;
}

.status-error {
  color: #dc2626;
  font-size: 14px;
  font-weight: 500;
}

.api-card-body {
  padding: 20px;
}

.test-btn {
  margin-top: 8px;
  padding: 10px 16px;
  font-size: 14px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.test-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Video API Configuration */
.video-api-config {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step-connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
}

.connector-line {
  width: 2px;
  height: 20px;
  background: #cbd5e1;
}

.connector-arrow {
  color: #64748b;
  font-size: 20px;
  font-weight: bold;
  margin-top: 4px;
}

/* Video Prompts Section */
.video-prompts-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.prompt-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.prompt-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.prompt-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.prompt-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

/* Form Input Error States */
.form-group input.error {
  border-color: #dc2626;
  background: #fef2f2;
}

.form-group input.error:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

/* Responsive Design for New Components */
@media (max-width: 768px) {
  .generation-type-toggle {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .type-label {
    padding: 16px;
    gap: 12px;
  }

  .type-icon {
    font-size: 24px;
    width: 40px;
    height: 40px;
  }

  .type-title {
    font-size: 16px;
  }

  .type-description {
    font-size: 13px;
  }

  .api-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .api-card-header h3 {
    font-size: 16px;
  }

  .step-indicator {
    font-size: 11px;
    padding: 4px 8px;
    min-width: 50px;
  }

  .video-api-config {
    gap: 16px;
  }

  .prompt-card {
    padding: 16px;
  }

  .prompt-header h4 {
    font-size: 14px;
  }
}

@media (max-width: 480px) {

  .generation-type-section,
  .api-configuration-section {
    padding: 16px;
  }

  .type-label {
    padding: 12px;
    gap: 8px;
  }

  .api-card-header,
  .api-card-body {
    padding: 16px;
  }

  .prompt-card {
    padding: 12px;
  }
}

/* ===== FOLDER MANAGEMENT STYLES ===== */

/* Folder Management Section */
.folder-management-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.folder-management-section h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
}

.upload-mode-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
}

.upload-mode-toggle .btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background: white;
  transition: all 0.2s ease;
  min-height: 100px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

.upload-mode-toggle .btn:hover {
  border-color: #4f46e5;
  background: #f8fafc;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.upload-mode-toggle .btn.btn-primary {
  border-color: #4f46e5;
  background: #f0f4ff;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

/* Ensure all three buttons have equal width and alignment */
.upload-mode-toggle .btn:nth-child(1),
.upload-mode-toggle .btn:nth-child(2),
.upload-mode-toggle .btn:nth-child(3) {
  flex: 1 1;
  min-width: 0;
}

.btn-icon {
  font-size: 32px;
  margin-bottom: 8px;
  display: block;
}

.btn-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.btn-text strong {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.btn-text small {
  font-size: 13px;
  color: #64748b;
  font-weight: 400;
}

.folder-selection {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

.selected-folder-info {
  margin-bottom: 16px;
}

.folder-info-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.folder-info-card .folder-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border-radius: 8px;
}

.folder-details {
  flex: 1 1;
}

.folder-details .folder-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.folder-details .folder-meta {
  font-size: 12px;
  color: #64748b;
}

.no-folder-selected {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #64748b;
  font-style: italic;
}

.no-folder-selected .folder-icon {
  font-size: 24px;
  opacity: 0.5;
}

.folder-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 16px;
}

.folder-actions .btn {
  padding: 8px 16px;
  font-size: 14px;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
  min-width: auto;
}

/* Folder Browser Modal */
.folder-browser {
  max-width: 600px;
  max-height: 80vh;
}

.folder-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.folder-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
}

.folder-item:hover {
  border-color: #4f46e5;
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.folder-item.selected {
  border-color: #4f46e5;
  background: #f0f4ff;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.folder-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border-radius: 8px;
}

.folder-info {
  flex: 1 1;
  min-width: 0;
}

.folder-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
  word-break: break-word;
}

.folder-meta {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 4px;
}

.folder-description {
  font-size: 13px;
  color: #6b7280;
  font-style: italic;
  margin-bottom: 4px;
}

.recent-badge {
  display: inline-block;
  background: #10b981;
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
}

/* Loading and Empty States */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #64748b;
}

.loading-state .spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #4f46e5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #64748b;
  text-align: center;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* Responsive Design for Folder Management */
@media (max-width: 768px) {
  .folder-management-section {
    padding: 16px;
  }

  .upload-mode-toggle {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .upload-mode-toggle .btn {
    min-height: 80px;
    padding: 16px;
  }

  .btn-icon {
    font-size: 28px;
  }

  .btn-text strong {
    font-size: 14px;
  }

  .btn-text small {
    font-size: 12px;
  }

  .folder-selection {
    padding: 12px;
  }

  .folder-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .folder-actions .btn {
    width: 100%;
    text-align: center;
  }

  .folder-browser {
    max-width: 95vw;
    margin: 20px;
  }

  .folder-item {
    padding: 12px;
    gap: 8px;
  }

  .folder-icon {
    font-size: 20px;
    width: 32px;
    height: 32px;
  }

  .folder-name {
    font-size: 14px;
  }

  .folder-meta {
    font-size: 12px;
  }

  .folder-description {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .folder-management-section {
    padding: 12px;
  }

  .upload-mode-toggle .btn {
    min-height: 70px;
    padding: 12px;
  }

  .btn-icon {
    font-size: 24px;
  }

  .btn-text strong {
    font-size: 13px;
  }

  .btn-text small {
    font-size: 11px;
  }

  .folder-item {
    padding: 8px;
    gap: 6px;
  }

  .folder-icon {
    font-size: 18px;
    width: 28px;
    height: 28px;
  }

  .tab-navigation {
    margin-bottom: 20px;
    padding: 3px;
  }

  .tab-button {
    padding: 12px 16px;
    font-size: 13px;
    min-height: 40px;
    gap: 6px;
  }

  .tab-icon {
    font-size: 14px;
  }
}

/* Collage View Styles */
.details-modal.collage-mode {
  max-width: 95vw;
  max-height: 98vh;
  width: 1400px;
  height: 97vh;
}

.details-modal .header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-toggle-view {
  padding: 8px 16px;
  border: 2px solid #4f46e5;
  background: white;
  color: #4f46e5;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-toggle-view:hover {
  background: #4f46e5;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(79, 70, 229, 0.3);
}

.btn-toggle-view.active {
  background: #4f46e5;
  color: white;
}

.zoom-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
}

.btn-zoom {
  width: 32px;
  height: 32px;
  border: none;
  background: white;
  color: #333;
  font-size: 20px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-zoom:hover {
  background: #4f46e5;
  color: white;
  transform: scale(1.1);
}

.btn-zoom-reset {
  padding: 4px 8px;
  border: none;
  background: white;
  color: #666;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-zoom-reset:hover {
  background: #4f46e5;
  color: white;
}

.zoom-level {
  min-width: 50px;
  text-align: center;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.collage-section {
  width: 100%;
  height: calc(97vh - 200px);
  overflow: auto;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 40px;
  transition: all 0.3s ease;
  scroll-behavior: smooth;
  position: relative;
}

.collage-wrapper {
  position: relative;
  transition: transform 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.collage-container {
  display: flex;
  gap: 20px;
  align-items: center;
  width: max-content;
  min-width: 100%;
}

.collage-item {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 400px;
}

/* Custom scrollbars for collage section - always visible for better UX */
.collage-section::-webkit-scrollbar {
  width: 16px;
  height: 16px;
}

.collage-section::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.collage-section::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #888 0%, #666 100%);
  border-radius: 8px;
  border: 2px solid #f1f1f1;
}

.collage-section::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #666 0%, #444 100%);
}

.collage-section::-webkit-scrollbar-corner {
  background: #f1f1f1;
}

/* Firefox scrollbar styling */
.collage-section {
  scrollbar-width: auto;
  scrollbar-color: #888 #f1f1f1;
}

.collage-label {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  text-align: center;
  padding: 8px 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.collage-image-wrapper {
  width: 100%;
  height: auto;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.collage-image {
  max-width: 100%;
  max-height: 600px;
  width: auto;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease;
  image-rendering: -webkit-optimize-contrast;
  /* High quality rendering */
  image-rendering: auto;
  /* High quality rendering */
  backface-visibility: hidden;
  transform: translateZ(0);
}

.collage-image:hover {
  transform: scale(1.05);
}

.collage-video {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.collage-divider {
  width: 2px;
  background: linear-gradient(to bottom, #e1e5e9, #4f46e5, #e1e5e9);
  align-self: stretch;
  position: relative;
}

.collage-divider::before {
  content: '→';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 8px 12px;
  border-radius: 50%;
  font-weight: 700;
  font-size: 18px;
  color: #4f46e5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.no-image-placeholder {
  width: 100%;
  height: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 8px;
  color: #999;
  font-size: 16px;
  font-weight: 500;
}

.collage-section .no-image-placeholder {
  border: 2px dashed #ddd;
}

/* Smooth transitions for modal */
.details-modal {
  transition: all 0.3s ease;
}

.details-modal.collage-mode .modal-body {
  height: calc(97vh - 120px);
  overflow: hidden;
  padding: 0;
}

.details-modal.collage-mode .modal-footer {
  padding: 12px 24px;
  min-height: 60px;
}

/* Responsive styles for collage view */
@media (max-width: 1200px) {
  .details-modal.collage-mode {
    width: 95vw;
  }

  .collage-item {
    min-width: 350px;
  }

  .collage-image-wrapper {
    min-height: 350px;
  }
}

@media (max-width: 768px) {
  .details-modal.collage-mode {
    width: 98vw;
    height: 95vh;
  }

  .details-modal.collage-mode .modal-body {
    height: calc(95vh - 120px);
  }

  .collage-section {
    padding: 20px;
    height: calc(95vh - 200px);
  }

  .header-actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .btn-toggle-view {
    font-size: 12px;
    padding: 6px 12px;
  }

  .zoom-controls {
    font-size: 12px;
    padding: 4px 8px;
  }

  .btn-zoom {
    width: 28px;
    height: 28px;
    font-size: 18px;
  }

  .zoom-level {
    min-width: 40px;
    font-size: 12px;
  }

  .collage-label {
    font-size: 14px;
    padding: 6px 12px;
  }

  .collage-item {
    min-width: 320px;
  }

  .collage-image-wrapper {
    min-height: 300px;
    padding: 12px;
  }

  .collage-image {
    max-height: 400px;
  }

  .collage-container {
    flex-direction: row;
  }

  .collage-divider {
    width: 2px;
    height: auto;
  }

  /* Smaller scrollbars on mobile */
  .collage-section::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
}

/* =====================================================
   Prompt Library Styles
   ===================================================== */

.prompt-section-enhanced {
  margin-bottom: 16px;
}

.prompt-library-section {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.prompt-library-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.prompt-library-header label {
  font-weight: 600;
  color: #1e293b;
  font-size: 15px;
}

.prompt-library-header .loading-indicator {
  font-size: 12px;
  color: #4f46e5;
  font-weight: 500;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

/* --- Enhanced Prompt Library UI --- */
.prompt-library-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.prompt-library-card:hover {
  box-shadow: 0 8px 30px rgba(79, 70, 229, 0.08);
  border-color: #cbd5e1;
}

.prompt-library-card .card-header {
  padding: 16px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prompt-library-card .header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.prompt-library-card .header-title .icon {
  font-size: 20px;
}

.prompt-library-card .header-title h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.prompt-library-card .loading-tag {
  background: #eef2ff;
  color: #4f46e5;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  animation: pulse 2s infinite;
}

.prompt-library-card .card-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.prompt-library-card .control-row {
  display: flex;
  gap: 20px;
  align-items: flex-end;
}

.prompt-library-card .attribute-row {
  padding-top: 15px;
  border-top: 1px dashed #e2e8f0;
}

.prompt-library-card .control-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.prompt-library-card .flex-grow {
  flex: 1 1;
}

.prompt-library-card label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.prompt-library-card .premium-select,
.prompt-library-card .premium-select-sm {
  width: 100%;
  padding: 12px 16px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}

.prompt-library-card .premium-select-sm {
  min-width: 200px;
  padding: 10px 14px;
}

/* Searchable Autocomplete Premium Styling */
.premium-autocomplete-input .MuiOutlinedInput-root {
  background: white !important;
  border: 2px solid #e2e8f0 !important;
  border-radius: 10px !important;
  transition: all 0.2s ease !important;
}

.premium-autocomplete-input .MuiOutlinedInput-root:hover {
  border-color: #94a3b8 !important;
}

.premium-autocomplete-input .MuiOutlinedInput-root.Mui-focused {
  border-color: #4f46e5 !important;
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1) !important;
}

.premium-autocomplete-input .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

.premium-autocomplete-input .MuiInputBase-input {
  font-size: 14px !important;
  color: #334155 !important;
  font-weight: 500 !important;
}

.prompt-library-card .premium-select:hover,
.prompt-library-card .premium-select-sm:hover {
  border-color: #94a3b8;
}

.prompt-library-card .premium-select:focus,
.prompt-library-card .premium-select-sm:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
}

.prompt-library-card .refresh-btn-premium {
  padding: 12px 24px;
  height: 48px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-weight: 600;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.prompt-library-card .refresh-btn-premium:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #4f46e5;
  color: #4f46e5;
  transform: translateY(-1px);
}

.prompt-library-card .refresh-btn-premium .icon {
  font-size: 16px;
}

/* --- Premium Variable Preview --- */
.prompt-preview-section {
  background: #fdf2f2;
  /* Light tint to distinguish from main form */
  background: linear-gradient(to bottom right, #f8fafc, #f1f5f9);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
}

.prompt-preview-section label {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
  font-size: 15px;
}

.prompt-preview-section .preview-text {
  line-height: 1.8;
  color: #334155;
  font-size: 15px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  position: relative;
}

/* --- Premium Highlight Effect --- */
.variable-highlight {
  display: inline-block;
  background: #eef2ff;
  color: #4338ca;
  padding: 2px 8px;
  margin: 0 2px;
  border-radius: 6px;
  font-weight: 700;
  border: 1px solid #c7d2fe;
  box-shadow: 0 2px 5px rgba(79, 70, 229, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: help;
  position: relative;
  animation: highlightFadeIn 0.5s ease-out forwards;
}

.variable-highlight:hover {
  background: #4338ca;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(67, 56, 202, 0.4);
  transform: translateY(-2px);
  border-color: #4338ca;
}

.prompt-preview-section .variables-list {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.prompt-preview-section .variables-list small {
  font-size: 13px;
  font-weight: 500;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 5px;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.6;
  }
}

@keyframes highlightFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive adjustments for prompt library */
@media (max-width: 1024px) {
  .prompt-library-card .control-row {
    flex-wrap: wrap;
  }

  .prompt-library-card .premium-select-sm {
    min-width: 150px;
    flex: 1 1;
  }
}

@media (max-width: 768px) {
  .prompt-library-card .control-row {
    flex-direction: column;
    align-items: stretch;
  }

  .prompt-library-card .refresh-btn-premium {
    width: 100%;
    justify-content: center;
  }

  .prompt-library-card .premium-select-sm {
    min-width: 100%;
  }

  .prompt-library-card .card-body {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminAITest/AdminAITest.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,4DAA4D;;AAE5D,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qFAAqF;EACrF,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,2CAA2C;;AAE3C,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,yCAAyC;AACzC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;;AAEzC,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,4DAA4D;AAC5D;;;EAGE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EAEtB,wBAAwB;EAExB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAE3B,2BAA2B;EAE3B,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iEAAiE;EACjE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;0DAE0D;;AAE1D;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yDAA6P;EAC7P,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,8DAA8D;EAC9D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAO;EACT;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".admin-ai-test {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.admin-ai-test h1 {\n  color: #333;\n  margin-bottom: 8px;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.admin-ai-test .subtitle {\n  color: #666;\n  margin-bottom: 32px;\n  font-size: 16px;\n}\n\n.test-form-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.test-form-section h2 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.form-row.single {\n  grid-template-columns: 1fr;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  padding: 12px;\n  border: 2px solid #e1e5e9;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  background: white;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.form-group textarea {\n  min-height: 100px;\n  resize: vertical;\n  font-family: inherit;\n}\n\n/* Upload Mode Toggle - Moved to folder management section */\n\n/* Folder Upload Section */\n.folder-upload-section {\n  padding: 20px;\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  background: #f9f9f9;\n  margin-bottom: 20px;\n}\n\n.folder-upload-section .form-group {\n  margin-bottom: 15px;\n}\n\n.folder-upload-section input[type=\"file\"] {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n}\n\n.file-info {\n  margin-top: 10px;\n}\n\n.selected-files {\n  background: white;\n  padding: 15px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n\n.selected-files ul {\n  margin: 10px 0 0 0;\n  padding-left: 20px;\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.selected-files li {\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #666;\n}\n\n.upload-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.upload-actions .btn {\n  padding: 10px 20px;\n  font-size: 14px;\n  border-radius: 6px;\n}\n\n.s3-preview-section {\n  margin-top: 20px;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.s3-preview-section h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.s3-images-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 12px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.s3-image-item {\n  background: white;\n  border-radius: 8px;\n  padding: 8px;\n  text-align: center;\n  border: 1px solid #e2e8f0;\n  transition: transform 0.2s;\n}\n\n.s3-image-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.s3-image-item img {\n  width: 100%;\n  height: 80px;\n  object-fit: cover;\n  border-radius: 4px;\n  margin-bottom: 4px;\n}\n\n.s3-image-item .filename {\n  font-size: 10px;\n  color: #666;\n  word-break: break-all;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n  flex-wrap: wrap;\n}\n\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n}\n\n.btn-primary {\n  background: #4f46e5;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #4338ca;\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background: #6b7280;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #555c68;\n}\n\n.btn-success {\n  background: #10b981;\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background: #059669;\n}\n\n.btn-outlined {\n  background: transparent;\n  color: #1976d2;\n  border: 2px solid #1976d2;\n  height: 40px;\n  min-width: 100px;\n  width: auto;\n  padding: 8px 16px;\n  font-weight: 600;\n  text-transform: none;\n  border-radius: 8px;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-outlined:hover:not(:disabled) {\n  background: rgba(25, 118, 210, 0.04);\n  border-width: 2px;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.results-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.results-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.results-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.batch-status {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.status-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.status-item {\n  text-align: center;\n  padding: 12px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.status-number {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.status-label {\n  font-size: 12px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-completed .status-number {\n  color: #10b981;\n}\n\n.status-failed .status-number {\n  color: #ef4444;\n}\n\n.status-processing .status-number {\n  color: #f59e0b;\n}\n\n.status-pending .status-number {\n  color: #6b7280;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-top: 12px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #4f46e5, #7c3aed);\n  transition: width 0.3s ease;\n}\n\n.generation-results {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n}\n\n/* New Generation Card Styles */\n.generation-card {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0;\n  transition: all 0.3s ease;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.generation-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  border-color: #4f46e5;\n}\n\n/* Card Header */\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.status-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.completed {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-badge.failed {\n  background: #fef2f2;\n  color: #991b1b;\n}\n\n.status-badge.processing {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge.pending {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.generation-id {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n/* Progress Circle */\n.progress-circle-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.progress-circle {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.progress-ring {\n  transform: rotate(-90deg);\n  transition: all 0.3s ease;\n}\n\n.progress-ring-circle {\n  transition: stroke-dashoffset 0.3s ease;\n}\n\n.progress-text {\n  position: absolute;\n  font-size: 10px;\n  font-weight: 600;\n  color: #374151;\n}\n\n/* Images Section */\n.images-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 16px 20px;\n}\n\n.image-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.image-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.image-wrapper {\n  position: relative;\n  width: 100%;\n  height: 180px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 2px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: transform 0.2s ease;\n  background: #f8fafc;\n}\n\n.card-image:hover {\n  transform: scale(1.02);\n}\n\n/* Specific styling for videos in cards */\n.card-video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #f8fafc;\n}\n\n.card-image video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #f8fafc;\n}\n\n.no-image-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  color: #6b7280;\n  font-size: 12px;\n  font-style: italic;\n  border: 2px dashed #cbd5e1;\n}\n\n.processing-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #4f46e5;\n}\n\n.processing-indicator .spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #4f46e5;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Card Footer */\n.card-footer {\n  padding: 12px 20px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n  padding: 4px 0;\n}\n\n.detail-item.error {\n  color: #dc2626;\n  background: #fef2f2;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #fecaca;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 10px;\n}\n\n.detail-value {\n  color: #6b7280;\n  font-size: 11px;\n  text-align: right;\n  max-width: 60%;\n  word-break: break-all;\n}\n\n.detail-value.filename {\n  font-family: monospace;\n  background: #f1f5f9;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n}\n\n/* Legacy styles for backward compatibility */\n.generation-item {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  transition: transform 0.2s;\n}\n\n.generation-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.generation-image {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.generation-info {\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n}\n\n.history-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n}\n\n.history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.history-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.history-filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n}\n\n\n.history-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  table-layout: fixed;\n}\n\n.history-table th,\n.history-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.history-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #374151;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.history-table tr:hover {\n  background: #f8fafc;\n}\n\n/* Table Image Cells */\n.image-cell {\n  width: 120px;\n  padding: 8px;\n  text-align: center;\n}\n\n/* Column Widths */\n.history-table th:nth-child(1),\n/* ID */\n.history-table td:nth-child(1) {\n  width: 60px;\n}\n\n.history-table th:nth-child(2),\n/* Status */\n.history-table td:nth-child(2) {\n  width: 100px;\n}\n\n.history-table th:nth-child(3),\n/* Format */\n.history-table td:nth-child(3) {\n  width: 80px;\n}\n\n.history-table th:nth-child(4),\n/* Input */\n.history-table td:nth-child(4) {\n  width: 140px;\n}\n\n.history-table th:nth-child(5),\n/* Output */\n.history-table td:nth-child(5) {\n  width: 140px;\n}\n\n.history-table th:nth-child(6),\n/* Created */\n.history-table td:nth-child(6) {\n  width: 140px;\n}\n\n.history-table th:nth-child(7),\n/* Time */\n.history-table td:nth-child(7) {\n  width: 80px;\n}\n\n.history-table th:nth-child(8),\n/* Actions */\n.history-table td:nth-child(8) {\n  width: 80px;\n}\n\n.table-image-container {\n  width: 100px;\n  height: 80px;\n  margin: 0 auto;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 2px solid #e2e8f0;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.table-image-container:hover {\n  border-color: #4f46e5;\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.2);\n}\n\n.table-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  background: #f8fafc;\n}\n\n.table-video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  background: #f8fafc;\n}\n\n.table-image-placeholder {\n  width: 100px;\n  height: 80px;\n  margin: 0 auto;\n  border-radius: 6px;\n  border: 2px dashed #cbd5e1;\n  background: #f1f5f9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  color: #6b7280;\n  text-align: center;\n  line-height: 1.2;\n  padding: 4px;\n}\n\n.table-image-error {\n  width: 100px;\n  height: 80px;\n  margin: 0 auto;\n  border-radius: 6px;\n  border: 2px solid #fecaca;\n  background: #fef2f2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  color: #dc2626;\n  text-align: center;\n  line-height: 1.2;\n  padding: 4px;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.pagination button {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.pagination button:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination .active {\n  background: #4f46e5;\n  color: white;\n  border-color: #4f46e5;\n}\n\n.error-message {\n  background: #fef2f2;\n  color: #991b1b;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  border: 1px solid #fecaca;\n}\n\n.success-message {\n  background: #f0fdf4;\n  color: #166534;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  border: 1px solid #bbf7d0;\n}\n\n.info-message {\n  background: #eff6ff;\n  color: #1e40af;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  border: 1px solid #bfdbfe;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #4f46e5;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-right: 8px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.tab-navigation {\n  display: flex;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  margin-bottom: 32px;\n  padding: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.tab-button {\n  flex: 1;\n  padding: 16px 24px;\n  background: transparent;\n  border: none;\n  font-size: 15px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 48px;\n}\n\n.tab-button:hover:not(.active) {\n  color: #374151;\n  background: #f9fafb;\n  transform: translateY(-1px);\n}\n\n.tab-button.active {\n  color: #ffffff;\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  transform: translateY(-2px);\n}\n\n.tab-button.active::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);\n  border-radius: 8px;\n  pointer-events: none;\n}\n\n.tab-icon {\n  font-size: 18px;\n  transition: transform 0.2s ease;\n}\n\n.tab-button:hover .tab-icon {\n  transform: scale(1.1);\n}\n\n.tab-button.active .tab-icon {\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\n}\n\n@media (max-width: 768px) {\n  .admin-ai-test {\n    padding: 16px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n  }\n\n  .btn {\n    justify-content: center;\n  }\n\n  .s3-images-grid {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  }\n\n  .generation-results {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .generation-card {\n    margin-bottom: 16px;\n  }\n\n  .card-header {\n    padding: 12px 16px;\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .status-section {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .progress-circle-container {\n    align-self: flex-end;\n  }\n\n  .images-section {\n    grid-template-columns: 1fr;\n    gap: 16px;\n    padding: 16px;\n  }\n\n  .image-wrapper {\n    height: 200px;\n  }\n\n  .card-footer {\n    padding: 12px 16px;\n  }\n\n  .detail-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .detail-value {\n    text-align: left;\n    max-width: 100%;\n  }\n\n  .history-filters {\n    grid-template-columns: 1fr;\n  }\n\n  .history-table {\n    font-size: 12px;\n  }\n\n  .history-table th,\n  .history-table td {\n    padding: 8px 4px;\n  }\n\n  .image-cell {\n    width: 80px;\n    padding: 4px;\n  }\n\n  .table-image-container {\n    width: 80px;\n    height: 60px;\n  }\n\n  .table-image-placeholder,\n  .table-image-error {\n    width: 80px;\n    height: 60px;\n    font-size: 9px;\n  }\n\n  .status-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .tab-navigation {\n    flex-wrap: wrap;\n    padding: 4px;\n    margin-bottom: 24px;\n  }\n\n  .tab-button {\n    flex: 1;\n    min-width: 120px;\n    padding: 14px 20px;\n    font-size: 14px;\n    min-height: 44px;\n  }\n\n  .tab-icon {\n    font-size: 16px;\n  }\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n/* Image modal should appear above details modal */\n.image-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.image-modal {\n  max-width: 800px;\n}\n\n/* Video styling in modals */\n.image-modal video {\n  max-width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  display: block;\n  margin: 0 auto;\n  background: #000;\n  border-radius: 8px;\n}\n\n.details-modal {\n  max-width: 1000px;\n  width: 90vw;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.close-btn:hover {\n  background: #e2e8f0;\n  color: #374151;\n}\n\n.modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n/* Details Content Styles */\n.details-content {\n  max-width: 100%;\n}\n\n.details-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  flex-wrap: wrap;\n}\n\n.format-info,\n.time-info {\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Details modal specific image section */\n.details-content .images-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n/* For video generation with 4 steps, use 2x2 grid */\n.details-content .images-section:has(.image-container:nth-child(4)) {\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n}\n\n.details-content .image-container {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n.image-container h4 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.image-preview {\n  cursor: pointer;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 2px solid #e2e8f0;\n  transition: border-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 250px;\n  max-height: 300px;\n  height: 250px;\n}\n\n.image-preview:hover {\n  border-color: #4f46e5;\n}\n\n.no-image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 250px;\n  color: #6b7280;\n  font-style: italic;\n  background: #f1f5f9;\n  border-radius: 6px;\n  border: 2px dashed #cbd5e1;\n}\n\n.details-section {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.details-section h4 {\n  margin: 0 0 16px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.details-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Details modal specific detail items */\n.details-content .detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.details-content .detail-item strong {\n  color: #374151;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.details-content .detail-item:not(.error) {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.details-content .detail-item.error {\n  color: #dc2626;\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n.details-content .detail-item.error strong {\n  color: #991b1b;\n}\n\n/* API URL styling in details */\n.api-url {\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  background: #f1f5f9;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n  word-break: break-all;\n  display: inline-block;\n  max-width: 100%;\n  cursor: help;\n}\n\n/* Generation parameters section styling */\n.details-list .detail-item:nth-child(n+7) {\n  border-top: 1px solid #e2e8f0;\n  padding-top: 12px;\n  margin-top: 8px;\n}\n\n.details-list .detail-item:nth-child(7) {\n  border-top: 2px solid #4f46e5;\n  padding-top: 12px;\n  margin-top: 12px;\n}\n\n.details-list .detail-item:nth-child(7) strong {\n  color: #4f46e5;\n  font-weight: 600;\n}\n\n/* Button Styles for Table */\n.btn-small {\n  padding: 6px 12px;\n  font-size: 12px;\n  border-radius: 6px;\n}\n\n/* Responsive Modal */\n@media (max-width: 768px) {\n  .modal-content {\n    max-width: 95vw;\n    max-height: 95vh;\n  }\n\n  .images-section {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .images-section:has(.image-container:nth-child(4)) {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n  }\n\n  .details-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-footer {\n    padding: 12px 20px;\n  }\n}\n\n/* ===== NEW PROFESSIONAL UI STYLES ===== */\n\n/* Generation Type Selection */\n.generation-type-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.generation-type-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 16px;\n}\n\n.type-option {\n  position: relative;\n}\n\n.type-option input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.type-label {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n  border: 2px solid #e1e5e9;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.type-option input[type=\"radio\"]:checked+.type-label {\n  border-color: #4f46e5;\n  background: #f8fafc;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.type-option:hover .type-label {\n  border-color: #4f46e5;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.type-icon {\n  font-size: 32px;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  border-radius: 8px;\n}\n\n.type-content {\n  flex: 1;\n}\n\n.type-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.type-description {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n/* API Configuration Section */\n.api-configuration-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n/* API Cards */\n.api-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.api-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.api-card-header {\n  background: white;\n  padding: 20px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.api-card-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.step-indicator {\n  background: #4f46e5;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 60px;\n  text-align: center;\n}\n\n.api-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-success {\n  color: #059669;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.status-error {\n  color: #dc2626;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.api-card-body {\n  padding: 20px;\n}\n\n.test-btn {\n  margin-top: 8px;\n  padding: 10px 16px;\n  font-size: 14px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.test-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Video API Configuration */\n.video-api-config {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.step-connector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 10px 0;\n}\n\n.connector-line {\n  width: 2px;\n  height: 20px;\n  background: #cbd5e1;\n}\n\n.connector-arrow {\n  color: #64748b;\n  font-size: 20px;\n  font-weight: bold;\n  margin-top: 4px;\n}\n\n/* Video Prompts Section */\n.video-prompts-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.prompt-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  transition: all 0.3s ease;\n}\n\n.prompt-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.prompt-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.prompt-header h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Form Input Error States */\n.form-group input.error {\n  border-color: #dc2626;\n  background: #fef2f2;\n}\n\n.form-group input.error:focus {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n/* Responsive Design for New Components */\n@media (max-width: 768px) {\n  .generation-type-toggle {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .type-label {\n    padding: 16px;\n    gap: 12px;\n  }\n\n  .type-icon {\n    font-size: 24px;\n    width: 40px;\n    height: 40px;\n  }\n\n  .type-title {\n    font-size: 16px;\n  }\n\n  .type-description {\n    font-size: 13px;\n  }\n\n  .api-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .api-card-header h3 {\n    font-size: 16px;\n  }\n\n  .step-indicator {\n    font-size: 11px;\n    padding: 4px 8px;\n    min-width: 50px;\n  }\n\n  .video-api-config {\n    gap: 16px;\n  }\n\n  .prompt-card {\n    padding: 16px;\n  }\n\n  .prompt-header h4 {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .generation-type-section,\n  .api-configuration-section {\n    padding: 16px;\n  }\n\n  .type-label {\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .api-card-header,\n  .api-card-body {\n    padding: 16px;\n  }\n\n  .prompt-card {\n    padding: 12px;\n  }\n}\n\n/* ===== FOLDER MANAGEMENT STYLES ===== */\n\n/* Folder Management Section */\n.folder-management-section {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.folder-management-section h3 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  text-align: center;\n}\n\n.upload-mode-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.upload-mode-toggle .btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  border-radius: 12px;\n  border: 2px solid #e2e8f0;\n  background: white;\n  transition: all 0.2s ease;\n  min-height: 100px;\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.upload-mode-toggle .btn:hover {\n  border-color: #4f46e5;\n  background: #f8fafc;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.upload-mode-toggle .btn.btn-primary {\n  border-color: #4f46e5;\n  background: #f0f4ff;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n/* Ensure all three buttons have equal width and alignment */\n.upload-mode-toggle .btn:nth-child(1),\n.upload-mode-toggle .btn:nth-child(2),\n.upload-mode-toggle .btn:nth-child(3) {\n  flex: 1;\n  min-width: 0;\n}\n\n.btn-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.btn-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.btn-text strong {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.btn-text small {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 400;\n}\n\n.folder-selection {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.selected-folder-info {\n  margin-bottom: 16px;\n}\n\n.folder-info-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.folder-info-card .folder-icon {\n  font-size: 24px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  border-radius: 8px;\n}\n\n.folder-details {\n  flex: 1;\n}\n\n.folder-details .folder-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.folder-details .folder-meta {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.no-folder-selected {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  color: #64748b;\n  font-style: italic;\n}\n\n.no-folder-selected .folder-icon {\n  font-size: 24px;\n  opacity: 0.5;\n}\n\n.folder-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.folder-actions .btn {\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\n.btn-sm {\n  padding: 4px 8px;\n  font-size: 12px;\n  min-width: auto;\n}\n\n/* Folder Browser Modal */\n.folder-browser {\n  max-width: 600px;\n  max-height: 80vh;\n}\n\n.folder-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.folder-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.folder-item:hover {\n  border-color: #4f46e5;\n  background: #f8fafc;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.folder-item.selected {\n  border-color: #4f46e5;\n  background: #f0f4ff;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.folder-icon {\n  font-size: 24px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  border-radius: 8px;\n}\n\n.folder-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.folder-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n  word-break: break-word;\n}\n\n.folder-meta {\n  font-size: 14px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.folder-description {\n  font-size: 13px;\n  color: #6b7280;\n  font-style: italic;\n  margin-bottom: 4px;\n}\n\n.recent-badge {\n  display: inline-block;\n  background: #10b981;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n/* Loading and Empty States */\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.loading-state .spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #4f46e5;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  color: #64748b;\n  text-align: center;\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Responsive Design for Folder Management */\n@media (max-width: 768px) {\n  .folder-management-section {\n    padding: 16px;\n  }\n\n  .upload-mode-toggle {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .upload-mode-toggle .btn {\n    min-height: 80px;\n    padding: 16px;\n  }\n\n  .btn-icon {\n    font-size: 28px;\n  }\n\n  .btn-text strong {\n    font-size: 14px;\n  }\n\n  .btn-text small {\n    font-size: 12px;\n  }\n\n  .folder-selection {\n    padding: 12px;\n  }\n\n  .folder-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .folder-actions .btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .folder-browser {\n    max-width: 95vw;\n    margin: 20px;\n  }\n\n  .folder-item {\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .folder-icon {\n    font-size: 20px;\n    width: 32px;\n    height: 32px;\n  }\n\n  .folder-name {\n    font-size: 14px;\n  }\n\n  .folder-meta {\n    font-size: 12px;\n  }\n\n  .folder-description {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .folder-management-section {\n    padding: 12px;\n  }\n\n  .upload-mode-toggle .btn {\n    min-height: 70px;\n    padding: 12px;\n  }\n\n  .btn-icon {\n    font-size: 24px;\n  }\n\n  .btn-text strong {\n    font-size: 13px;\n  }\n\n  .btn-text small {\n    font-size: 11px;\n  }\n\n  .folder-item {\n    padding: 8px;\n    gap: 6px;\n  }\n\n  .folder-icon {\n    font-size: 18px;\n    width: 28px;\n    height: 28px;\n  }\n\n  .tab-navigation {\n    margin-bottom: 20px;\n    padding: 3px;\n  }\n\n  .tab-button {\n    padding: 12px 16px;\n    font-size: 13px;\n    min-height: 40px;\n    gap: 6px;\n  }\n\n  .tab-icon {\n    font-size: 14px;\n  }\n}\n\n/* Collage View Styles */\n.details-modal.collage-mode {\n  max-width: 95vw;\n  max-height: 98vh;\n  width: 1400px;\n  height: 97vh;\n}\n\n.details-modal .header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.btn-toggle-view {\n  padding: 8px 16px;\n  border: 2px solid #4f46e5;\n  background: white;\n  color: #4f46e5;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-toggle-view:hover {\n  background: #4f46e5;\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(79, 70, 229, 0.3);\n}\n\n.btn-toggle-view.active {\n  background: #4f46e5;\n  color: white;\n}\n\n.zoom-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f8f9fa;\n  padding: 6px 12px;\n  border-radius: 8px;\n  border: 1px solid #e1e5e9;\n}\n\n.btn-zoom {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: white;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btn-zoom:hover {\n  background: #4f46e5;\n  color: white;\n  transform: scale(1.1);\n}\n\n.btn-zoom-reset {\n  padding: 4px 8px;\n  border: none;\n  background: white;\n  color: #666;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-zoom-reset:hover {\n  background: #4f46e5;\n  color: white;\n}\n\n.zoom-level {\n  min-width: 50px;\n  text-align: center;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.collage-section {\n  width: 100%;\n  height: calc(97vh - 200px);\n  overflow: auto;\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 40px;\n  transition: all 0.3s ease;\n  scroll-behavior: smooth;\n  position: relative;\n}\n\n.collage-wrapper {\n  position: relative;\n  transition: transform 0.3s ease;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  will-change: transform;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.collage-container {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  width: max-content;\n  min-width: 100%;\n}\n\n.collage-item {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 400px;\n}\n\n/* Custom scrollbars for collage section - always visible for better UX */\n.collage-section::-webkit-scrollbar {\n  width: 16px;\n  height: 16px;\n}\n\n.collage-section::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 8px;\n}\n\n.collage-section::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #888 0%, #666 100%);\n  border-radius: 8px;\n  border: 2px solid #f1f1f1;\n}\n\n.collage-section::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #666 0%, #444 100%);\n}\n\n.collage-section::-webkit-scrollbar-corner {\n  background: #f1f1f1;\n}\n\n/* Firefox scrollbar styling */\n.collage-section {\n  scrollbar-width: auto;\n  scrollbar-color: #888 #f1f1f1;\n}\n\n.collage-label {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  text-align: center;\n  padding: 8px 16px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.collage-image-wrapper {\n  width: 100%;\n  height: auto;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.collage-image {\n  max-width: 100%;\n  max-height: 600px;\n  width: auto;\n  height: auto;\n  border-radius: 8px;\n  object-fit: contain;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  image-rendering: -webkit-optimize-contrast;\n  /* High quality rendering */\n  image-rendering: auto;\n  /* High quality rendering */\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n.collage-image:hover {\n  transform: scale(1.05);\n}\n\n.collage-video {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.collage-divider {\n  width: 2px;\n  background: linear-gradient(to bottom, #e1e5e9, #4f46e5, #e1e5e9);\n  align-self: stretch;\n  position: relative;\n}\n\n.collage-divider::before {\n  content: '→';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 8px 12px;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 18px;\n  color: #4f46e5;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.no-image-placeholder {\n  width: 100%;\n  height: 100%;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 8px;\n  color: #999;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.collage-section .no-image-placeholder {\n  border: 2px dashed #ddd;\n}\n\n/* Smooth transitions for modal */\n.details-modal {\n  transition: all 0.3s ease;\n}\n\n.details-modal.collage-mode .modal-body {\n  height: calc(97vh - 120px);\n  overflow: hidden;\n  padding: 0;\n}\n\n.details-modal.collage-mode .modal-footer {\n  padding: 12px 24px;\n  min-height: 60px;\n}\n\n/* Responsive styles for collage view */\n@media (max-width: 1200px) {\n  .details-modal.collage-mode {\n    width: 95vw;\n  }\n\n  .collage-item {\n    min-width: 350px;\n  }\n\n  .collage-image-wrapper {\n    min-height: 350px;\n  }\n}\n\n@media (max-width: 768px) {\n  .details-modal.collage-mode {\n    width: 98vw;\n    height: 95vh;\n  }\n\n  .details-modal.collage-mode .modal-body {\n    height: calc(95vh - 120px);\n  }\n\n  .collage-section {\n    padding: 20px;\n    height: calc(95vh - 200px);\n  }\n\n  .header-actions {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .btn-toggle-view {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n\n  .zoom-controls {\n    font-size: 12px;\n    padding: 4px 8px;\n  }\n\n  .btn-zoom {\n    width: 28px;\n    height: 28px;\n    font-size: 18px;\n  }\n\n  .zoom-level {\n    min-width: 40px;\n    font-size: 12px;\n  }\n\n  .collage-label {\n    font-size: 14px;\n    padding: 6px 12px;\n  }\n\n  .collage-item {\n    min-width: 320px;\n  }\n\n  .collage-image-wrapper {\n    min-height: 300px;\n    padding: 12px;\n  }\n\n  .collage-image {\n    max-height: 400px;\n  }\n\n  .collage-container {\n    flex-direction: row;\n  }\n\n  .collage-divider {\n    width: 2px;\n    height: auto;\n  }\n\n  /* Smaller scrollbars on mobile */\n  .collage-section::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n  }\n}\n\n/* =====================================================\n   Prompt Library Styles\n   ===================================================== */\n\n.prompt-section-enhanced {\n  margin-bottom: 16px;\n}\n\n.prompt-library-section {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.prompt-library-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.prompt-library-header label {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.prompt-library-header .loading-indicator {\n  font-size: 12px;\n  color: #4f46e5;\n  font-weight: 500;\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* --- Enhanced Prompt Library UI --- */\n.prompt-library-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.prompt-library-card:hover {\n  box-shadow: 0 8px 30px rgba(79, 70, 229, 0.08);\n  border-color: #cbd5e1;\n}\n\n.prompt-library-card .card-header {\n  padding: 16px 24px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.prompt-library-card .header-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.prompt-library-card .header-title .icon {\n  font-size: 20px;\n}\n\n.prompt-library-card .header-title h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.prompt-library-card .loading-tag {\n  background: #eef2ff;\n  color: #4f46e5;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  animation: pulse 2s infinite;\n}\n\n.prompt-library-card .card-body {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.prompt-library-card .control-row {\n  display: flex;\n  gap: 20px;\n  align-items: flex-end;\n}\n\n.prompt-library-card .attribute-row {\n  padding-top: 15px;\n  border-top: 1px dashed #e2e8f0;\n}\n\n.prompt-library-card .control-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.prompt-library-card .flex-grow {\n  flex: 1;\n}\n\n.prompt-library-card label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.prompt-library-card .premium-select,\n.prompt-library-card .premium-select-sm {\n  width: 100%;\n  padding: 12px 16px;\n  background: #ffffff;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #334155;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n}\n\n.prompt-library-card .premium-select-sm {\n  min-width: 200px;\n  padding: 10px 14px;\n}\n\n/* Searchable Autocomplete Premium Styling */\n.premium-autocomplete-input .MuiOutlinedInput-root {\n  background: white !important;\n  border: 2px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  transition: all 0.2s ease !important;\n}\n\n.premium-autocomplete-input .MuiOutlinedInput-root:hover {\n  border-color: #94a3b8 !important;\n}\n\n.premium-autocomplete-input .MuiOutlinedInput-root.Mui-focused {\n  border-color: #4f46e5 !important;\n  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1) !important;\n}\n\n.premium-autocomplete-input .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n.premium-autocomplete-input .MuiInputBase-input {\n  font-size: 14px !important;\n  color: #334155 !important;\n  font-weight: 500 !important;\n}\n\n.prompt-library-card .premium-select:hover,\n.prompt-library-card .premium-select-sm:hover {\n  border-color: #94a3b8;\n}\n\n.prompt-library-card .premium-select:focus,\n.prompt-library-card .premium-select-sm:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);\n}\n\n.prompt-library-card .refresh-btn-premium {\n  padding: 12px 24px;\n  height: 48px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-weight: 600;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n}\n\n.prompt-library-card .refresh-btn-premium:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #4f46e5;\n  color: #4f46e5;\n  transform: translateY(-1px);\n}\n\n.prompt-library-card .refresh-btn-premium .icon {\n  font-size: 16px;\n}\n\n/* --- Premium Variable Preview --- */\n.prompt-preview-section {\n  background: #fdf2f2;\n  /* Light tint to distinguish from main form */\n  background: linear-gradient(to bottom right, #f8fafc, #f1f5f9);\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.prompt-preview-section label {\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 16px;\n  font-size: 15px;\n}\n\n.prompt-preview-section .preview-text {\n  line-height: 1.8;\n  color: #334155;\n  font-size: 15px;\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n  position: relative;\n}\n\n/* --- Premium Highlight Effect --- */\n.variable-highlight {\n  display: inline-block;\n  background: #eef2ff;\n  color: #4338ca;\n  padding: 2px 8px;\n  margin: 0 2px;\n  border-radius: 6px;\n  font-weight: 700;\n  border: 1px solid #c7d2fe;\n  box-shadow: 0 2px 5px rgba(79, 70, 229, 0.08);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: help;\n  position: relative;\n  animation: highlightFadeIn 0.5s ease-out forwards;\n}\n\n.variable-highlight:hover {\n  background: #4338ca;\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(67, 56, 202, 0.4);\n  transform: translateY(-2px);\n  border-color: #4338ca;\n}\n\n.prompt-preview-section .variables-list {\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.prompt-preview-section .variables-list small {\n  font-size: 13px;\n  font-weight: 500;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.6;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.6;\n  }\n}\n\n@keyframes highlightFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive adjustments for prompt library */\n@media (max-width: 1024px) {\n  .prompt-library-card .control-row {\n    flex-wrap: wrap;\n  }\n\n  .prompt-library-card .premium-select-sm {\n    min-width: 150px;\n    flex: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .prompt-library-card .control-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .prompt-library-card .refresh-btn-premium {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .prompt-library-card .premium-select-sm {\n    min-width: 100%;\n  }\n\n  .prompt-library-card .card-body {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
